import { clamp, finiteOr, saturate } from "../physics/numbers";
import type { InputFrame } from "./types";

export const createNeutralInput = (overrides: Partial<InputFrame> = {}): InputFrame => ({
  throttle: 0,
  brake: 0,
  steer: 0,
  drift: false,
  boost: false,
  recoverPressed: false,
  pausePressed: false,
  resetPressed: false,
  ...overrides
});

export const sanitizeInputFrame = (input: InputFrame): InputFrame => ({
  throttle: saturate(finiteOr(input.throttle, 0)),
  brake: saturate(finiteOr(input.brake, 0)),
  steer: clamp(finiteOr(input.steer, 0), -1, 1),
  drift: input.drift,
  boost: input.boost,
  recoverPressed: input.recoverPressed,
  pausePressed: input.pausePressed,
  resetPressed: input.resetPressed
});
